<template>
	<b-modal ref="modal" :title="`Edit sound for ${curUserEventType.event_name||curUserEventType.event_type}`">
		<b-form @submit.stop.prevent="save()" id="userEventTypeEditForm">
			<b-form-row v-if="curUserEventType">
				<b-col>
					<b-form-group label="Sounds">
						<pipi-pupu-multi-file v-model="curUserEventType.sounds" accept="audio/*"></pipi-pupu-multi-file>
					</b-form-group>
					<b-form-group label="Images">
						<pipi-pupu-multi-file v-model="curUserEventType.images" accept="image/*"></pipi-pupu-multi-file>
					</b-form-group>
				</b-col>
			</b-form-row>
		</b-form>
		<b-alert variant="danger" :show="!!error" class="mt-4 mb-0">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button size="sm" variant="success" type="submit" form="userEventTypeEditForm">
				Save
			</b-button>
			<b-button size="sm" @click="cancel()">Close</b-button>
		</template>
	</b-modal>
</template>

<script>
import PipiPupuMultiFile from '../../../components/PipiPupuMultiFile.vue';

export default {
	data() { return {
		loading: 0,
		error: null,
		curUserEventType: {},
	}; },
	components: {
		PipiPupuMultiFile,
	},
	methods: {
		async show(messageType) {
			try {
				this.$refs.modal.show();
				this.loading++;
				this.error = null;
				this.curUserEventType = await this.$api.get(`userEventType/${messageType}`);
			} catch(err) {
				this.error = err;
			} finally {
				this.loading--;
			}
		},
		async save() {
			try {
				this.loading++;
				this.error = null;
				await this.$api.post(`userEventType/${this.curUserEventType.event_type}`, {
					sounds: (this.curUserEventType.sounds||[]).map(s => s.md5),
					images: (this.curUserEventType.images||[]).map(s => s.md5),
				});
				this.$refs.modal.hide();
				this.$emit('saved');
			} catch(err) {
				this.error = err;
			} finally {
				this.loading--;
			}
		},
	}
}
</script>
